/*
    Imports
*/
import { Alert, Collapse } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import { useState } from 'react';

import LoadingFormButton from 'src/components/misc/Buttons/LoadingFormButton';
import { TwoFactorAuthSchema } from 'src/config/form-schemas';
import userService from 'src/services/UserServiceClass';
import OneTimePassword from 'src/components/misc/Forms/OneTimePassword';

/*
    Main Working
*/
export default ({ userUID, onSuccess }) => {
    /*
      States, Params, Navigation, Query.
    */
    const [serverError, setServerError] = useState('');

    /*
      Form Setup
    */
    const formik = useFormik({
        initialValues: {
            code: '',
        },
        validationSchema: TwoFactorAuthSchema,
        onSubmit: (values, { setSubmitting }) => {
            userService
                .verify2fa(userUID, values.code)
                .then((data) => {
                    onSuccess(data);
                })
                .catch((err) => {
                    console.error('Error', err);
                    setSubmitting(false);
                    if (!err.response) {
                        setServerError('Error occurred please try later');
                    } else {
                        const errorMsg =
                            err.response.data.msg || err.response.data.error.description;
                        setServerError(errorMsg);
                    }
                });
        },
    });
    const { errors, touched, isSubmitting, handleSubmit, setFieldValue } = formik;

    /*
      Main Design
    */
    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Collapse in={!!serverError}>
                    <Alert sx={{ mb: 2 }} severity="error">
                        {serverError}
                    </Alert>
                </Collapse>

                <OneTimePassword
                    onChange={(val) => {
                        setFieldValue('code', val);
                    }}
                    error={Boolean(touched.code && errors.code)}
                    helperText={touched.code && errors.code}
                />

                <LoadingFormButton
                    style={{ padding: '0px 70px', marginTop: '20px' }}
                    size="large"
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                >
                    Verify
                </LoadingFormButton>
            </Form>
        </FormikProvider>
    );
};
